import SensorIssueData from "./data";

export default function mapSensorIssueDataFromJson(json) {
  return new SensorIssueData(
    json.id,
    json.vesselId,
    new Date(json.startTime),
    json.checkValue,
    json.checkLimit,
    json.checkName,
    json.checkWording,
    json.sensorName,
    json.is_persistent === 1  // <- Convert 0/1 to boolean
  );
}
